import { merge, assign } from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  data: {},
  item: {},
  error: '',
  isFetching: false
};

const inventory = (state = initialState, action) => {
  const {
    data,
    error,
    isFetching,
    isPosting,
    item
  } = action;

  switch (action.type) {
  case types.INVENTORY_FETCH_REQUEST:
  case types.INVENTORY_ITEM_FETCH_REQUEST:
    return merge({}, state, {
      isFetching
    });

  case types.INVENTORY_ITEM_CREATE_REQUEST:
  case types.INVENTORY_ITEM_UPDATE_REQUEST:
    return merge({}, state, {
      isPosting
    });

  case types.INVENTORY_FETCH_SUCCESS:
    return assign({}, state, { data });

  case types.INVENTORY_ITEM_CREATE_SUCCESS:
    return merge({}, state, {
      data
    });

  case types.INVENTORY_ITEM_FETCH_SUCCESS:
  case types.INVENTORY_ITEM_STORE:
    return {
      ...state,
      item
    };

  case types.INVENTORY_FETCH_FAILURE:
  case types.INVENTORY_ITEM_FETCH_FAILURE:
  case types.INVENTORY_ITEM_UPDATE_FAILURE:
  case types.INVENTORY_ITEM_CREATE_FAILURE:
    return merge({}, state, {
      error
    });

  case types.RESET_INVENTORY_STORE:
    return initialState;

  default:
    return state;
  }
};

export default inventory;
